export const formatFilterDate = (date: Date) => {
    // Extract the year, month, and day
    let year = date.getFullYear();
    let month = ('0' + (date.getMonth() + 1)).slice(-2); // Add 1 to month and pad with zero if needed
    let day = ('0' + date.getDate()).slice(-2); // Pad with zero if needed

    // Combine into the desired format
    return `${year}-${month}-${day}`;
};
